import ClinicStatistical from '../clinicStatistical'
import { Card } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledCard = styled(Card)`
  border-radius: 12px;
  height: 100%;
  width: 300px !important;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .ant-card-body {
    padding: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  &:hover {
    border-color: var(--color-primary-108);
  }
  &.prevent-select:hover {
    border-color: #e4e8ec;
  }
  &.prevent-select.active:hover {
    border-color: var(--color-primary-108);
  }
  &.active {
    border-color: var(--color-primary-108);
    .statistical {
      background-color: var(--color-primary-103);
    }
  }
  &.prevent-select {
    cursor: not-allowed;
  }
`

const StyledTitle = styled.div`
  background: var(--color-gray-101);
  min-height: 28px;
  padding: 4px;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  align-items: center;
  text-align: center;
  font-weight: 600;
  font-size: 1.2rem;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
`

const StyledContent = styled.div`
  text-align: center;
  height: 50px;
  margin: 8px 0;
  line-height: 24px;
  flex: 1;
`

const StyledAcademic = styled.div`
  font-weight: 500;
  font-size: 1.4rem;
`

const StyledName = styled.div`
  font-weight: 700;
  font-size: 1.4rem;
  text-transform: uppercase;
`

const StyledStatistical = styled.div`
  display: flex;
  height: 58px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background: var(--color-primary-101);
`

const StyledStatisticalItem = styled(ClinicStatistical)`
  width: 33.33%;
  text-align: center;
  text-transform: uppercase;
`
const StyledDivider = styled.div`
  display: block;
  height: 38px;
  width: 1px;
  top: 10px;
  background: var(--color-primary-103);
`

export interface ICardStatistical {
  label: string
  value?: string | number
  color: string
}
interface IProps {
  title?: string
  academic?: string
  name?: string
  active?: boolean
  preventSelect?: boolean
  statisticalData?: Array<ICardStatistical>
  onClick?: () => void
}
const ClinicCard = (props: IProps) => {
  const {
    title,
    academic,
    active,
    name,
    onClick,
    preventSelect,
    statisticalData
  } = props
  const { t } = useTranslation()
  const handleOnClick = () => {
    if (onClick && !preventSelect) onClick()
  }
  return (
    <StyledCard
      onClick={handleOnClick}
      className={`${active ? 'active' : ''} ${
        preventSelect ? 'prevent-select' : ''
      }`}>
      <StyledTitle>{t(title || '')}</StyledTitle>
      <StyledContent>
        <StyledAcademic>{academic}</StyledAcademic>
        <StyledName>{name}</StyledName>
      </StyledContent>
      <StyledStatistical className="statistical">
        {statisticalData?.map((item, index) => (
          <React.Fragment key={index}>
            <StyledStatisticalItem
              title={item.label}
              value={item.value}
              color={item.color as any}
            />

            {index < statisticalData.length - 1 && <StyledDivider />}
          </React.Fragment>
        ))}
      </StyledStatistical>
    </StyledCard>
  )
}

export default ClinicCard
